// extracted by mini-css-extract-plugin
module.exports = {"btn":"AnimationButton_btn__oDyc_","is-primary":"AnimationButton_is-primary__f2V7y"};